@let localEdited = edited();

<mat-dialog-content class="modal-dialog modal-md" role="document">
  <div class="modal-content">
    <div class="modal-header text-center p-0 mb-3">
      <h2 class="modal-title w-500 unbold">
        {{ localEdited ? ('actualizacion_exitosa' | translate) : ('registro_exitoso' | translate) }}
      </h2>
      <span class="dismiss-modal" (click)="dialogRef.close()">X</span>
    </div>
    <div class="modal-body text-center p-0">
      @if (!localEdited) {
        <b class="bold-text">{{ 'tu_cuenta_ha_sido_registrada' | translate }}</b>
        <p class="text-center mb-3">
          {{ 'hemos_enviado_un_mensaje_confirmacion' | translate }}
        </p>
        <div>
          <p class="light-blue-text bol-text mb-3">
            {{ 'recuerda_que_puedes_usar_tu_mismo' | translate }}
          </p>
          <button class="light-blue mx-auto" (click)="dialogRef.close()">
            {{ 'entendido' | translate }}
          </button>
        </div>
      }
    </div>
  </div>
</mat-dialog-content>
